import axios from "axios";
import { Notification, NotificationError } from "@/util/noty";

export default {
  state: {
    stateSeguradoras: [],
  },
  getters: {
    stateSeguradoras: (state) => state.stateSeguradoras,
  },
  mutations: {
    _setSeguradoras(state, data) {
      state.stateSeguradoras = data;
    },
  },
  actions: {
    actionListarSeguradoras({ commit }) {
      axios
        .get(`${process.env.VUE_APP_API}/seguradoras`)
        .then((response) => {
          if (response.data.success) {
            commit("_setSeguradoras", response.data.data.seguradoras);
            return response.data.data.seguradoras;
          } else {
            Notification(
              "danger",
              response.data.data.message.title,
              response.data.data.message.description
            );
          }
        })
        .catch((error) => {
          NotificationError();
          throw error.response.data;
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
  },
};
